// removed by extract-text-webpack-plugin
module.exports = {"rbc-day-slot":"rbc-day-slot","rbc-time-slot":"rbc-time-slot","rbc-time-view":"rbc-time-view","rbc-time-header":"rbc-time-header","rbc-row":"rbc-row","rbc-time-content":"rbc-time-content","rbc-timeslot-group":"rbc-timeslot-group","rbc-header":"rbc-header","rbc-today":"rbc-today","rbc-weekday-sun":"rbc-weekday-sun","rbc-weekday-sat":"rbc-weekday-sat","rbc-header-gutter":"rbc-header-gutter"};


//////////////////
// WEBPACK FOOTER
// ./src/components/classtop-react-big-calendar/Calendar.scss
// module id = drs3
// module chunks = 0